import dropdown from "../../assets/images/icons/dropdown.png";

const DropDownIndicatorSvg = () => {
    return <img src={dropdown} alt="arrow" />;
};

export default DropDownIndicatorSvg;
